import {
  UsersService
} from '@/common/api.service'
import {
  FETCH_PROFILE,
  UPDATE_USER,
  DELETE_USER,
  CHANGE_PASSWORD
} from './actions.type'
import {
  FETCH_START,
  SET_USER_PROFILE
} from './mutations.type'

const state = {
  user: {},
  isLoading: true
}

const getters = {
  user(state) {
    return state.user
  }
}

const actions = {
  [FETCH_PROFILE]({ commit }) {
    // commit(FETCH_START)
    const params = {
      params: {
        includes: [
          'platform_user_authorizations.platform.application',
          'company.applications.platform',
          'company.users',
          'company.stores.place',
          'company.marketing_settings.setting',
          'company.notification_configs',
          'company.settings',
          'company.segment'
        ]
      }
    }
    return UsersService.get(params)
      .then(response => {
        commit(SET_USER_PROFILE, response.data)
        return response.data
      })
      .catch((error) => {
        throw new Error(error)
      })
  },
  [UPDATE_USER]({ state }, data) {
    return UsersService.update(data)
  },
  [DELETE_USER](context) {
    return UsersService.destroy()
  },
  [CHANGE_PASSWORD]({ state }, data) {
    return UsersService.changePassword(data)
  }
}

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [FETCH_START](state) {
    state.isLoading = true
  },
  [SET_USER_PROFILE](state, user) {
    // console.log(shippingsCount)
    state.user = user
    state.isLoading = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
